// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-0271f4ae]{fill:#fff}", ""]);
// Exports
module.exports = exports;
